// utils/idGenerator.js

export function generateBigIntId() {
  // 13-digit timestamp (milliseconds since 1970)
  const timestamp = Date.now(); 
  
  // 4-digit random number (1000-9999 to ensure fixed length)
  const randomSuffix = Math.floor(Math.random() * 9000) + 1000;
  
  // Combine into a single number (e.g., 17194012345671234)
  return timestamp +randomSuffix;
}

// For string representation (when needed)
export function bigIntToStr(id) {
  return id.toString();
}